var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define('modules/uv-ebookleftpanel-module/EbookLeftPanel',["require", "exports", "../uv-shared-module/BaseEvents", "../uv-shared-module/LeftPanel", "../../extensions/uv-ebook-extension/Events"], function (require, exports, BaseEvents_1, LeftPanel_1, Events_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var EbookLeftPanel = /** @class */ (function (_super) {
        __extends(EbookLeftPanel, _super);
        function EbookLeftPanel($element) {
            return _super.call(this, $element) || this;
        }
        EbookLeftPanel.prototype.create = function () {
            var _this = this;
            this.setConfig("ebookLeftPanel");
            _super.prototype.create.call(this);
            this._$container = $('<div class="container"></div>');
            this._ebookTOC = document.createElement("uv-ebook-toc");
            this._$ebookTOC = $(this._ebookTOC);
            //this._ebookTOC.setAttribute("src-tab-enabled", this.config.options.srcTabEnabled);
            this.$main.addClass("disabled");
            this.$main.append(this._$container);
            this._$container.append(this._$ebookTOC);
            this.setTitle(this.content.title);
            this.component.subscribe(Events_1.Events.LOADED_NAVIGATION, function (navigation) {
                _this.$main.removeClass("disabled");
                _this._ebookTOC.toc = navigation.toc;
            });
            this.component.subscribe(Events_1.Events.RELOCATED, function (location) {
                _this._ebookTOC.selected = location.start.href;
            });
            this._ebookTOC.addEventListener("itemClicked", function (e) {
                _this.component.publish(Events_1.Events.ITEM_CLICKED, e.detail);
            }, false);
            Utils.Async.waitFor(function () {
                return (window.customElements !== undefined);
            }, function () {
                customElements.whenDefined("uv-ebook-toc").then(function () {
                    _this.component.publish(Events_1.Events.TOC_READY);
                });
            });
        };
        EbookLeftPanel.prototype.expandFullStart = function () {
            _super.prototype.expandFullStart.call(this);
            this.component.publish(BaseEvents_1.BaseEvents.LEFTPANEL_EXPAND_FULL_START);
        };
        EbookLeftPanel.prototype.expandFullFinish = function () {
            _super.prototype.expandFullFinish.call(this);
            this.component.publish(BaseEvents_1.BaseEvents.LEFTPANEL_EXPAND_FULL_FINISH);
        };
        EbookLeftPanel.prototype.collapseFullStart = function () {
            _super.prototype.collapseFullStart.call(this);
            this.component.publish(BaseEvents_1.BaseEvents.LEFTPANEL_COLLAPSE_FULL_START);
        };
        EbookLeftPanel.prototype.collapseFullFinish = function () {
            _super.prototype.collapseFullFinish.call(this);
            this.component.publish(BaseEvents_1.BaseEvents.LEFTPANEL_COLLAPSE_FULL_FINISH);
        };
        EbookLeftPanel.prototype.resize = function () {
            _super.prototype.resize.call(this);
            this._$container.height(this.$main.height() - this._$container.verticalPadding());
        };
        return EbookLeftPanel;
    }(LeftPanel_1.LeftPanel));
    exports.EbookLeftPanel = EbookLeftPanel;
});

